import React, { Component } from 'react';
import './style.css';
import { Input, Button } from 'reactstrap';
import * as FontAwesome from 'react-icons/lib/fa'
import { Link } from 'react-router-dom';
import Loader from './../../loader/loader';

import { coffee_gr } from './../../../../utils/horoscope_gr';

import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
class CoffeeReadings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            contentLoading: true
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        setTimeout(() => this.setState({ contentLoading: false }), 1500);
    }
    render() {
        let coffee = [];
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        if (countryCode.countryCode === 'gr') {
            coffee = coffee_gr
        }
        // else if (countryCode.countryCode === 'es' || countryCode.countryCode === 'mx') {
        //     coffee = coffee_es
        // } else if (countryCode.countryCode === 'ee') {
        //     coffee = coffee_ee
        // }else if (countryCode.countryCode === 'nl') {
        //     coffee = coffee_nl
        // }    
        // else {
        //     coffee = coffee_en
        // }

        // let tarodCard = this.props.location.state.reading;
        let reading = coffee[this.props.location.state.reading];
        const { contentLoading } = this.state;
        if (contentLoading) {
            return <Loader />
        }
        return (
            <div className="coffeereading">
                <div className="coffeereading-box">
                    <div className="coffee-item coffee-headeing">
                        <div className="coffeereading-btn-section">
                            <Link to="/Coffeecups"><img src={require('./../../../assets/images/back-button.png')} className="back-button" /></Link>
                        </div>
                        <div className="heading-title">
                            <h1><FormattedMessage id="coffeereading.title"
                                defaultMessage="Coffee Cup Reading"
                                description=""
                                values={{}} /></h1>
                        </div>
                    </div>
                    <div className="coffee-item">
                        <div className="coffee-reading">
                            <div className="coffee-reading-card coffee-card-padding-right">
                                <img src={require(`./../../../assets/images/A.png`)} width="195" height="150" />
                            </div>
                        </div>
                    </div>
                    <div className="coffee-item">
                        <p className="daily-coffee text-bold text-color big">
                            <FormattedMessage id="coffeereading.subtitle"
                                defaultMessage="Daily coffee cup reading"
                                description=""
                                values={{}} />
                        </p>
                        <p>{reading}</p>
                    </div>
                </div>
            </div >
        )
    }
}

export default CoffeeReadings;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/coffeecupreading/coffeeReadings.js